import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ProductDetailPageDTO, ProductParureDTO } from 'src/app/models/types/Product/Product.type';
import { Filters, FiltersDTO, ProductsBodyPayload } from '../../models/types/Filters.type';
import { ProductDTO } from '../../models/types/Product/ProductDTO.type';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  private readonly apiUrl = `${environment.apiUrl}/Products`;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  /**
   * API per il reperimento dei prodotti tramite RULE
   * POST /api/Products/{rule}
   * @param rule
   */
  getProducts(rule: number, body: ProductsBodyPayload): Observable<ProductDTO> {
    const url = `${this.apiUrl}/${rule}`;
    return (this.http.post(url, body) as Observable<ProductDTO>);
  }

  /**
   * API per il reperimento dei filtri tramite RULE
   * POST /api/Products/Filters/{rule}
   * @param rule
   */
  getProductsFilters(rule: number, body: Filters): Observable<FiltersDTO> {
    const url = `${this.apiUrl}/Filters/${rule}`;
    return (this.http.post(url, body) as Observable<FiltersDTO>);
  }

  /**
   * API per il reperimento dei dati per la PDP
   * GET /api/Products/SapCode/{sapCode}
   * @param sapCode sapCode del prodotto
   */
  getPDP(sapCode: string): Observable<ProductDetailPageDTO> {
    const url = `${this.apiUrl}/SapCode/${sapCode}`;
    return (this.http.get(url) as Observable<ProductDetailPageDTO>)
  }

  /**
   * API per il reperimento delle eventuali parure e set di un prodotto
   * GET /api/Products/parure/SapCode/{sapCode}
   * @param sapCode sapCode del prodotto
   */
  getParure(sapCode: string): Observable<ProductParureDTO> {
    const url = `${this.apiUrl}/parure/SapCode/${sapCode}`;
    return (this.http.get(url) as Observable<ProductParureDTO>)
  }

  getPdf(sapCode: string, withPriceList?: boolean): Observable<any> {
    const isNotUserStore = this.authService.user?.isNotUserStore;
    const store = isNotUserStore ? this.authService.getDefaultStore() : this.authService.store;
    let printUrl = 'PrintProductDetails';
    if (withPriceList) {
      printUrl = 'PrintProductDetailsWithPriceList';
    }
    let baseUrl = environment.apiUrl; //Tolgo "api" dall'url
    let url = `${baseUrl}/${printUrl}/Product/${sapCode}/Store/${store?.idStore}`;
    return (this.http.get(url) as Observable<any>)
  }

  downloadFromUrl(url: string, fileName: string) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url.replaceAll('"', ''));
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  getDocumentFilename(url: string): Observable<string> {
    return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
      map(response => {
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="([^"]+)"/);
          let filename: any = 'file.pdf';
          try {
            if (match && match[1]) {
              filename = match[1];
            }
          } catch (error) {
            console.error('Error extracting filename', error);
            filename = 'file.pdf';
          } finally {
            return filename;
          }
        }
      }),
      catchError(e => throwError(() => e))
    );
  }

  /*

  func getDocumentFilename(url: String, completion: @escaping (Result<String,NetworkError>) -> Void) {

            let urlReq =  URLRequest(url: URL(string: url)!)
            var req = NetworkRequest(request: urlReq )
            let request = NetworkDispatcher.buildGetRequest(with: req)
            NetworkDispatcher.execute(request, completion: { (res: Result<Data,NetworkError>) in }) { (res: HTTPURLResponse?) in

                let string = res?.headers["Content-Disposition"]?.split(separator: "\"")[1]
                completion(.success(String(string ?? "")))
            }

        }

  */

}
